var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{attrs:{"id":"titleBar"}},[_c('div',{attrs:{"id":"tileTitle"}},[_c('p',{staticStyle:{"text-align":"left"}},[_vm._v(" "+_vm._s(_vm.tileSetName)+" ")])]),_c('button',{staticClass:"dataButton",on:{"click":_vm.openModal}},[_c('v-icon',{staticClass:"dataButtonIcon",attrs:{"name":"cloud-download-alt"}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }